<template>
  <div class="notify bottom">
    <div class="notifyHead">
      <div class="info">
        <div class="img" v-if="result">
          <img src="../assets/icons/win.svg" v-if="result == 'win'" />
          <img src="../assets/icons/lose.svg" v-else />
        </div>
        <p class="notifyText">
          {{ textNotify }} <span v-if="result" :class="result == 'win' ? 'win' : 'lose'">{{ resultAmount }} {{ resultSymbol }}</span>
        </p>
      </div>
      <div class="timerBlock" v-if="timely">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 7.3335V11.0002L13.75 12.8335M11 20.1668C5.93743 20.1668 1.83337 16.0628 1.83337 11.0002C1.83337 5.93755 5.93743 1.8335 11 1.8335C16.0626 1.8335 20.1667 5.93755 20.1667 11.0002C20.1667 16.0628 16.0626 20.1668 11 20.1668Z" stroke="var(--black-to-white)" stroke-opacity="0.3" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p>{{ timeLeft }} {{ $t("timerSec") }}</p>
      </div>
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" @click="$emit('closeNotify')" v-else>
        <rect x="19.9497" y="8.63623" width="1.6" height="16" rx="0.8" transform="rotate(45 19.9497 8.63623)" fill="#9E9EA1" />
        <rect x="21.3638" y="19.9502" width="1.6" height="16" rx="0.8" transform="rotate(135 21.3638 19.9502)" fill="#9E9EA1" />
      </svg>
    </div>
    <div class="progress-bar-background">
      <div class="progress-bar" :style="progressStyle"></div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      duration: Number,
      notify: String,
      timely: Boolean,
      result: String,
      resultAmount: String,
      resultSymbol: String,
      isBet: Boolean,
    },
    data() {
      return {
        timeLeft: this.duration, // Оставшееся время,
        textNotify: this.notify,
      }
    },
    methods: {
      startTimer() {
        // Прежде чем запустить setInterval, сразу уменьшаем время на 1 секунду
        setTimeout(() => {
          const interval = setInterval(() => {
            this.timeLeft -= 1
            if (this.timeLeft <= 0) {
              clearInterval(interval) // Останавливаем таймер, когда время истекает
              console.log(this.notify, this.duration)
              if (this.isBet) {
                this.textNotify = this.$t("summarizingBets")
              } else {
                setTimeout(() => {
                  this.$emit("closeNotify") // Закрываем уведомление
                }, 1200)
              }
            }
          }, 1000) // Каждую секунду уменьшаем время
        }, 0) // Таймер запускается мгновенно, минимизируя задержку
      },
    },
    mounted() {
      this.startTimer()
    },
    computed: {
      progressStyle() {
        // Вычисляем ширину полосы прогресса в процентах
        const percentage = (this.timeLeft / this.duration) * 100
        return {
          width: `${percentage}%`,
        }
      },
    },
  }
</script>
<style scoped>
  .notify {
    background-color: var(--second-color);
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 93%;
    border-radius: 10px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .notify.bottom {
    bottom: 5vh;
  }
  .notifyHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .info {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .notifyText {
    color: var(--text-color1);
    font-size: 16px;
    text-align: left;
  }
  .timerBlock {
    background-color: var(--background-color);
    border-radius: 50px;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px;
  }
  .progress-bar-background {
    width: 100%;
    height: 5px;
    background-color: #233b58; /* Фон полосы */
    border-radius: 2px;
    overflow: hidden;
  }

  .progress-bar {
    height: 100%;
    background-color: #007aff; /* Цвет самой полосы */
    transition: width 1s linear; /* Убираем плавную анимацию */
  }
  .win {
    color: #27c12d;
  }
  .lose {
    color: #ff5858;
  }
</style>
